module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAAdUlEQVQYV23PIQ6DUBCE4Y+71OHQrSVB1GA4QHUP0AtwATQoRDEoEpLa+rq6HqZ56SN5aViz2Zk/k9nMb0bcscQ7XWc0WVSOmHHFlFANOtQbGLwCK24YcEGLCq8UDHCOB544ocQ7GP9g0A7oY+Jnq7EH7vzDF1qLDud6tEgBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/select_down.png
// module id = 4g0j
// module chunks = 1